<div class="loading-screen d-flex justify-content-center align-items-center w-100"
  *ngIf="!cartStatus || cartStatus === 'LOADING' || cartStatus === 'ORDERSUBMITTED'">
  <div class="d-flex flex-column text-center">
    <div class="lds-ripple mx-auto">
      <div></div>
      <div></div>
    </div>
    <div class="loading-message">{{'public.load.loadingMessage' | translate}}</div>
  </div>
</div>
<div class="waiting-screen" *ngIf="showWaitingSreen()"></div>
<div class="position-relative" [style.height]="isPos ? innerHeight + 'px' : '100%'"
  [ngClass]="{'screen-blur': enableScreenBlur(), 'screen-waiting': showWaitingSreen()}">
  <div class="overflow-auto" [style.height]="isPos ? innerHeight + 'px' : '100%'" (scroll)="onResize($event)"
    #scrollableContaner>
    <div class="cart-wrapper"
      [ngClass]="{'added-to-cart': cartData && cartData.orderItems && cartData.orderItems.length > 0 && checkoutService.ifEnabledOrder()}">
      <div class="store-info languages position-relative mx-auto" #contentHeader>
        <div class="theme-light store-pd">
          <!-- Main header row -->
          <div class="header-main-row">
            <!-- Left: Back arrow -->
            <div class="header-icon">
              <a href="#"
                class="close-details d-flex m-1 arrow-icon position-absolute container-theme-light-icons round-background"
                (click)="onGoBack($event)">
                <i class="fa fa-arrow-left m-auto"></i>
              </a>
            </div>
            <div class="header-center-content text-center">
              <div class="text-center font-size-header font-weight-bold theme-light">
                {{'public.checkout.yourOrder' | translate}}
              </div>
              <div class="store-title d-block m-1 mt-3 text-center pb-2 lg-pb-2 font-size-primary theme-light-subtitle">
                {{(selectedStore$ | async)?.name}} <span *ngIf="(selectedStore$ | async)?.description">|</span>
                {{(selectedStore$ | async)?.description}}
              </div>
            </div>

            <div class="mx-auto header-language"> <app-store-catalog-language-selector [isRtl]="true"
                [haveBackground]="false"></app-store-catalog-language-selector></div>
          </div>
        </div>
        <div class="pb-2 bg-white" style="height: 20px;"></div>

      </div>
      <div class="content mx-auto position-relative" [ngStyle]="isTableOrdering ?{'min-height': 'auto'}:{}">

        <div class="item-left cart-content" [style.top.px]="contentHeaderHeight">
          <!-- ORDER ITEMS -->
          <div class="p-3 item-title mb-0 font-size-heading pl-4 theme-light text-center">
            Your items</div>
          <div class="item-list px-4 overflow-auto mx-auto" *ngIf="cartItems">
            <div class="mb-3">
              <ng-container *ngFor="let item of cartItems; last as isLastItem">
                <div *ngIf="item.quantity > 0" class="item-wrapper text-select-none d-flex flex-row pt-3"
                  [ngClass]="(!checkoutService.shouldDisplayTotal() && isLastItem) ? 'no-border-bottom' : ''"
                  (click)="viewProductDetails(item.uuid, item.offerId)">
                  <ng-template *ngIf="item.discountType; then showDiscount; else showNoDiscount">
                  </ng-template>
                  <!-- SHOW NO DISCOUNT CART ITEM -->
                  <ng-template #showNoDiscount>
                    <div class="mr-md-3 mr-2 mt-n-1" *ngIf="item.hierarchyLevel === 'PARENT'">
                      <div class="qty d-flex font-size-primary font-weight-bold text-unselectable">
                        <div class="decrement d-flex container-theme-light-icons"
                          (click)="onDecreaseItemQty($event, item)">
                          <i class="fa fa-minus m-auto"></i>
                        </div>
                        <div class="value mx-md-3 mx-2 font-size-primary theme-color-header">{{item.quantity}}</div>
                        <div class="increment d-flex container-theme-light-icons"
                          (click)="onIncreaseItemQty($event, item)">
                          <i class="fa fa-plus m-auto"></i>
                        </div>
                      </div>
                    </div>
                    <div class="item flex-fill mb-3 w-25 text-unselectable">
                      <div class="p-0 mb-0 font-size-primary font-weight-bold theme-color-header text-pretty">
                        {{ item.itemName }}
                        <span class="text-nowrap font-size-primary theme-color-header d-inline-block"
                          [ngClass]="{'d-none': (!this.checkoutService.isShowParentItemPrice(item) || (item.offerPrice === 0))}">
                          ( {{ item.offerPrice | formatPrice:
                          checkoutService.selectedStoreLocale:checkoutService.selectedStoreCurrency:checkoutService.selectedStoreCurrencySymbol
                          }} )
                          <span class="ml-3 edit-icon" *ngIf="item.hierarchyLevel === 'PARENT'">
                            <i class="fa fas fa-pen theme-color-header"></i>
                          </span>
                        </span>
                        
                      </div>
                      <div class="child-order-item p-0 mb-0 font-size-primary text-unselectable"
                        *ngIf="item.priceDescription">
                        {{ item.priceDescription }}
                      </div>
                      <div class="child-order-item p-0 mb-0 font-size-primary text-unselectable"
                        *ngFor="let childOrderItem of item.childOrderItems">
                        {{ childOrderItem.quantity > 1 ? childOrderItem.quantity + ' x' : '' }} {{
                        childOrderItem.itemName
                        }}
                        <span class="text-nowrap" *ngIf="childOrderItem.offerPrice && childOrderItem.offerPrice !== 0">
                          ( {{ childOrderItem.offerPrice | formatPrice:
                          checkoutService.selectedStoreLocale:checkoutService.selectedStoreCurrency:checkoutService.selectedStoreCurrencySymbol
                          }} )
                        </span>
                      </div>
                      <div class="child-order-item p-0 mb-0 font-size-primary text-unselectable" *ngIf="item.comment">
                        "{{ item.comment }}"
                      </div>
                      <div *ngIf="item.wishTime" class="child-order-item p-0 mb-0 font-size-primary text-unselectable">
                        {{ isTimeShowDisabled() ? '' : item.wishTime | formattedTime:
                        selectedStore?.settings?.TIME_FORMAT_SELECTION: selectedStore?.locale }}
                        {{item.wishTime | localizedDate:'ddd DD MMM':(userLang$ | async):browserTimeZone | async }}
                      </div>
                    </div>
                    <div class="price text-right font-size-primary text-unselectable pl-3"
                      *ngIf="item.totalNonDiscountedPrice !== 0 && (item.hierarchyLevel === 'PARENT' || item.hierarchyLevel === 'RULE')">
                      {{ itemTotalNonDiscountedValue(item) | formatPrice:
                      checkoutService.selectedStoreLocale:checkoutService.selectedStoreCurrency:checkoutService.selectedStoreCurrencySymbol
                      }}
                    </div>
                  </ng-template>

                  <!-- SHOW DISCOUNT CART ITEM -->
                  <ng-template #showDiscount>
                    <div class="mr-md-3 mr-2 mt-n-2" *ngIf="item.hierarchyLevel === 'PARENT'">
                      <div class="qty d-flex font-size-primary font-weight-bold text-unselectable">
                        <div class="decrement d-flex container-theme-light-icons"
                          (click)="onDecreaseItemQty($event, item)">
                          <i class="fa fa-minus m-auto"></i>
                        </div>
                        <div class="value mx-md-3 mx-2 font-size-primary theme-color-header">{{item.quantity}}</div>
                        <div class="increment d-flex container-theme-light-icons"
                          (click)="onIncreaseItemQty($event, item)">
                          <i class="fa fa-plus m-auto"></i>
                        </div>
                      </div>
                    </div>
                    <div class="item flex-fill mb-3 w-25 text-unselectable">
                      <!-- when discount is applied always show original item price -->

                      <div class="p-0 mb-0 font-size-primary font-weight-bold theme-color-header text-pretty">
                        {{ item.itemName }}
                        <span [ngClass]="{'d-none': ((item.offerPrice === 0))}"
                          class="text-nowrap font-size-primary theme-color-header d-inline-block">
                          ({{ item.offerPrice | formatPrice:
                          checkoutService.selectedStoreLocale:checkoutService.selectedStoreCurrency:checkoutService.selectedStoreCurrencySymbol
                          }})
                          <span class="ml-3 edit-icon theme-color-header" *ngIf="item.hierarchyLevel === 'PARENT'">
                            <i class="fa fas fa-pen theme-color-header"></i>
                          </span>
                        </span>

                      </div>
                      <div class="child-order-item p-0 mb-0 font-size-primary text-unselectable"
                        *ngIf="item.priceDescription font-size-primary">
                        {{ item.priceDescription }}
                      </div>
                      <ng-template
                        *ngIf="item.discountType === 'MONETARY'; then showMonetaryDiscount; else showPercentileDiscount">
                      </ng-template>
                      <ng-template #showMonetaryDiscount>
                        <div class="discount p-0 mb-0 font-size-primary text-nowrap text-unselectable"
                          *ngIf="item.discountValue > 0">{{'public.global.discount' | translate}}
                          <ng-container *ngIf="item.discountValue > 0">
                            (- {{ item.discountValue | formatPrice:
                            checkoutService.selectedStoreLocale:checkoutService.selectedStoreCurrency:checkoutService.selectedStoreCurrencySymbol
                            }})
                          </ng-container>
                        </div>
                      </ng-template>
                      <ng-template #showPercentileDiscount>
                        <div class="discount p-0 mb-0 font-size-primary text-nowrap text-unselectable"
                          *ngIf="item.discountValue > 0">{{'public.global.discount' | translate}} {{ item.discountValue
                          }}%
                          <ng-container *ngIf="(item.offerPrice * item.discountValue / 100) > 0">
                            (- {{ item.offerPrice * item.discountValue / 100 | formatPrice:
                            checkoutService.selectedStoreLocale:checkoutService.selectedStoreCurrency:checkoutService.selectedStoreCurrencySymbol
                            }} )
                          </ng-container>

                        </div>
                      </ng-template>
                      <div class="child-order-item p-0 mb-0 font-size-primary text-unselectable"
                        *ngFor="let childOrderItem of item.childOrderItems">
                        {{ childOrderItem.quantity > 1 ? childOrderItem.quantity + ' x' : '' }} {{
                        childOrderItem.itemName
                        }}
                        <span class="text-nowrap" *ngIf="childOrderItem.offerPrice && childOrderItem.offerPrice !== 0">
                          ( {{ childOrderItem.offerPrice | formatPrice:
                          checkoutService.selectedStoreLocale:checkoutService.selectedStoreCurrency:checkoutService.selectedStoreCurrencySymbol
                          }} )
                        </span>
                      </div>
                      <div class="child-order-item p-0 mb-0 font-size-primary text-unselectable"
                        *ngIf="item.comment font-size-primary">
                        "{{ item.comment }}"
                      </div>
                    </div>
                    <div class="price text-right"
                      *ngIf="item.totalNonDiscountedPrice > 0 && (item.hierarchyLevel === 'PARENT' || item.hierarchyLevel === 'RULE')">
                      <div class="font-size-primary text-unselectable" [ngClass]="{'striked': item.discountValue > 0}">
                        {{
                        itemTotalNonDiscountedValue(item) |
                        formatPrice:
                        checkoutService.selectedStoreLocale:checkoutService.selectedStoreCurrency:checkoutService.selectedStoreCurrencySymbol
                        }}</div>
                      <div class="discount-value font-size-primary text-unselectable" *ngIf="item.discountValue > 0">{{
                        itemTotalDiscountedValue(item) |
                        formatPrice:
                        checkoutService.selectedStoreLocale:checkoutService.selectedStoreCurrency:checkoutService.selectedStoreCurrencySymbol
                        }}</div>
                    </div>
                  </ng-template>
                </div>
              </ng-container>
            </div>
            <!-- SHOW DELIVERY FEE: IF APPLICABLE -->
            <div
              *ngIf="checkoutService.getOrderFeeDelivery() && (checkoutService.ifOnlyDeliveryToAddress() || checkoutService.deliveryFeeApply())"
              class="d-flex flex-row mb-2">
              <div class="total flex-fill mb-3 font-size-primary text-unselectable font-weight-bold theme-color-header">
                {{'public.checkout.deliveryFee' | translate}}
              </div>
              <div class="price text-right font-size-primary text-unselectable">
                {{ checkoutService.getOrderFeeDelivery() | formatPrice:
                checkoutService.selectedStoreLocale:checkoutService.selectedStoreCurrency:checkoutService.selectedStoreCurrencySymbol
                }}
              </div>
            </div>
            <!-- SHOW Transaction Fee: IF APPLICABLE -->
            <div *ngIf="!isAdminOrderCaptureUpdate && checkoutService.getTransactionFees() > 0.0"
              class="d-flex flex-row mb-2">
              <div class="total flex-fill mb-3 font-size-primary text-unselectable font-weight-bold theme-color-header">
                {{'public.global.transaction.fee' | translate}}
              </div>
              <div class="price text-right font-size-primary text-unselectable"
                *ngIf="checkoutService.getTransactionFees() > 0.0">
                {{ checkoutService.getTransactionFees() | formatPrice:
                checkoutService.selectedStoreLocale:checkoutService.selectedStoreCurrency:checkoutService.selectedStoreCurrencySymbol
                }}
              </div>
            </div>
            <!-- SHOW SERVICE CHARGE: IF APPLICABLE -->
            <div *ngIf="checkoutService.getOrderServiceCharge() && checkoutService.isShowReadOnlyLocation()"
              class="d-flex flex-row mb-2">
              <div class="total flex-fill mb-3 font-size-primary text-unselectable font-weight-bold theme-color-header">
                {{'admin.store.serviceCharge' | translate}} ({{cartData.serviceChargePercentage}}%)
              </div>
              <div class="price text-right font-size-primary text-unselectable">
                {{ checkoutService.getOrderServiceCharge() | formatPrice:
                checkoutService.selectedStoreLocale:checkoutService.selectedStoreCurrency:checkoutService.selectedStoreCurrencySymbol
                }}
              </div>
            </div>
            <div #totalOrderPrice id="totalOrderPrice" class="cart-total-wrapper mb-4 text-unselectable"
              *ngIf="checkoutService.shouldDisplayTotal()">
              <div class="d-flex flex-row">
                <div class="total flex-fill font-size-primary text-unselectable font-weight-bold theme-color-header"
                  id="total-checkout-page">
                  {{'public.checkout.total' | translate}}
                </div>
                <div class="price text-right font-size-primary text-unselectable font-weight-bold theme-color-header"
                  [class.striked]="checkoutService.getCartDiscountType()">
                  {{ checkoutService.getCartTotalWithoutVoucher(true) | formatPrice:
                  checkoutService.selectedStoreLocale:checkoutService.selectedStoreCurrency:checkoutService.selectedStoreCurrencySymbol
                  }}
                </div>
              </div>
              <div class="d-flex flex-row">
                <div class="flex-fill p-0 mb-0 font-size-primary text-unselectable"
                  *ngIf="checkoutService.getCartDiscountType() === 'MONETARY'">
                  {{'public.global.discount' | translate}} (- {{ checkoutService.getCartDiscountValue() | formatPrice:
                  checkoutService.selectedStoreLocale:checkoutService.selectedStoreCurrency:checkoutService.selectedStoreCurrencySymbol
                  }})
                  <i class="fa-solid fa-tag mt-1 ml-2 discounted-value fs-12"></i>
                </div>
                <div class="flex-fill p-0 mb-0 d-flex flex-row"
                  *ngIf="checkoutService.getCartDiscountType() === 'PERCENTILE'">
                  <div class="font-size-primary text-unselectable">
                    {{'public.global.discount' | translate}} (- {{ checkoutService.getCartDiscountValue() | formatPrice:
                    checkoutService.selectedStoreLocale:checkoutService.selectedStoreCurrency:checkoutService.selectedStoreCurrencySymbol
                    }} )
                  </div>
                  <i class="fa-solid fa-tag mt-1 ml-2 discounted-value fs-12"></i>
                  <div class="font-size-primary text-unselectable discount-value pl-2">
                    -{{checkoutService.getCartDiscountPercentage()}}%
                  </div>
                </div>
                <div class="price discount-value text-right font-size-primary text-unselectable font-weight-bold"
                  *ngIf="checkoutService.getCartDiscountType() != null">
                  {{ checkoutService.getCartDiscountedPrice() | formatPrice:
                  checkoutService.selectedStoreLocale:checkoutService.selectedStoreCurrency:checkoutService.selectedStoreCurrencySymbol
                  }}
                </div>
              </div>
            </div>

          </div>
          <div class="min-amount text-danger px-3 pb-1 pl-4 font-size-secondary text-unselectable"
            *ngIf="!checkoutService.ifMinimumOrderAmountMet('onlyDelivery') || !checkoutService.ifMinimumOrderAmountMet('onlyLocation') || !checkoutService.ifMinimumOrderAmountMet('')">
            {{'public.checkout.minimumAmount' | translate:{'amount': checkoutService.getFormattedMinAmount()} }}
          </div>
          <div class="voucher-desk">
            <app-store-checkout-voucher-code
              *ngIf="selectedStore.settings['VOUCHER_AT_CHECKOUT_ENABLED'] === true"></app-store-checkout-voucher-code>

            <app-store-checkout-special-note *ngIf="selectedStore.settings['HIDE_ORDER_COMMENTS'] === false"
              #specialNoteComponent></app-store-checkout-special-note>
          </div>
          <!-- EOF: ORDER OPTIONS -->
        </div>
        <div class="item-right">
          <!-- CHECKOUT OPTIONS -->
          <ng-template
            *ngIf="checkoutService.ifEnabledOrder() || (checkoutService.ifEnabledOrderCapture() && isAdminOrderCaptureUpdate) && !checkoutService.ifNoDeliveryAvailable(); then showOrderOptions; else showThankYouNote">
          </ng-template>

          <ng-template #showThankYouNote>
            <div class="thank-you-note mx-3" *ngIf="cartItems">
              <h3 class="font-size-heading text-unselectable theme-color-header">{{'public.global.thankYou' |
                translate}}!</h3>
              <div class="font-size-primary text-unselectable"
                *ngIf="!checkoutService.ifEnabledOrder() || checkoutService.ifNoDeliverySupported(); else storeClosed">
                {{'public.checkout.cardDisabledNote' | translate:{'storeName': (selectedStore$ | async)?.name} }}
              </div>
              <ng-template #storeClosed>
                <div class="font-size-primary text-unselectable">
                  {{'public.store.currently.closed' | translate }}
                </div>
              </ng-template>
            </div>
          </ng-template>
          <ng-template #showOrderOptions>
            <!-- <div class="content pb-6 mx-auto"> -->
            <div class="voucher-moblie">
              <app-store-checkout-voucher-code
                *ngIf="selectedStore.settings['VOUCHER_AT_CHECKOUT_ENABLED'] === true"></app-store-checkout-voucher-code>
              <app-store-checkout-special-note *ngIf="selectedStore.settings['HIDE_ORDER_COMMENTS'] === false"
                #specialNoteComponent></app-store-checkout-special-note>
            </div>
            <!-- EOF: ORDER OPTIONS -->


            <!-- STORE PROMOTIONS -->
            <app-store-checkout-promotion #checkOutPromotionComponent></app-store-checkout-promotion>
            <!-- EOF: STORE PROMOTIONS -->
            <!-- NEW CHECKOUT OPTIONS -->
            <app-store-checkout-delivery (scrollTo)="scrollTo()" #checkoutDelivery></app-store-checkout-delivery>
            <!-- EOF NEW CHECKOUT OPTIONS -->

            <!-- STORE RULES FOR DELIVERY FEE -->
            <app-store-checkout-fee-rules #checkoutFeeRule></app-store-checkout-fee-rules>
            <!-- EOF: STORE RULES FOR DELIVERY FEE -->

            <div class="option-wrapper">

              <!-- WISHTIME COMPONENT -->
              <app-store-checkout-order-wish-time-panel *ngIf="!isAdminOrderUpdate"
                (scrollToWishComponent)="scrollToWish()" [(showClosedStoreMessage)]="showClosedStoreMessage"
                #wishTimeComponent></app-store-checkout-order-wish-time-panel>

              <!-- EOF: WISHTIME COMPONENT -->
              <div class="option-box">
                <div id="personalInformation"
                  class="p-3 section-title mb-4 pl-4 position-relative font-medium font-size-heading theme-light"
                  [ngClass]="{  'd-none': !checkoutService.showChoices() || checkoutService.allFieldsHiddenForPickup()}">
                  {{'public.checkout.yourInformationPlease' | translate}}
                </div>
                <!-- EXPANDABLE CONTENT -->
                <div class="expandable-content-wrapper">
                  <!-- DELIVERY AT LOCATION -->
                  <app-store-checkout-delivery-at-location
                    #deliveryAtLocationComponent></app-store-checkout-delivery-at-location>
                  <!-- PERSONAL INFORMATION -->

                  <ng-template
                    *ngIf="checkoutService.isShowReadOnlyLocation(); then showReadOnlyLocation"></ng-template>
                  <ng-template #showReadOnlyLocation>
                    <app-store-checkout-readonly-location
                      #yourInformationComponent></app-store-checkout-readonly-location>
                  </ng-template>

                  <ng-template *ngIf="checkoutService.isShowOnlySelfPickup(); then showOnlySelfPickup"></ng-template>
                  <ng-template #showOnlySelfPickup>
                    <app-store-checkout-selfpickup #yourInformationComponent></app-store-checkout-selfpickup>
                  </ng-template>

                  <ng-template
                    *ngIf="checkoutService.isShowOnlyDeliveryToAddress() && !checkoutService.showReadOnlyLocation(); then showOnlyDeliveryToAddress"></ng-template>
                  <ng-template #showOnlyDeliveryToAddress>
                    <app-store-checkout-delivery-to-address
                      #yourInformationComponent></app-store-checkout-delivery-to-address>
                  </ng-template>

                </div>

              </div>
              <!-- EOF: EXPANDABLE CONTENT -->
            </div>
            <!-- EOF: PERSONAL INFORMATION -->
            <!-- BILLING INFORMATION -->
            <app-store-checkout-billing-info></app-store-checkout-billing-info>
            <!-- EOF: BILLING INFORMATION -->
            <app-store-checkout-buzzer></app-store-checkout-buzzer>
            <!-- PAYMENT OPTIONS AND METHODS -->
            <app-store-checkout-payment
              *ngIf="isAdminOrderCaptureUpdate ? !isAdminOrderUpdate && this.isAdminPaymentComponent() : !isAdminOrderUpdate && checkoutService.isPaymentComponent()"
              (scrollToPayment)="scrollToPayment()" #paymentComponent></app-store-checkout-payment>
            <!-- EOF: PAYMENT OPTIONS AND METHODS -->
            <!-- </div> -->
          </ng-template>


          <div class="payment-button-wrapper  mx-auto" [formGroup]="termsAcceptedForm"
            *ngIf="(checkoutService.ifEnabledOrder() || (checkoutService.ifEnabledOrderCapture() && isAdminOrderCaptureUpdate)) && !checkoutService.ifNoDeliveryAvailable()">
            <div class="bg-white">
              <div class="sticky-scroll text-center position-absolute" *ngIf="showStickyScroll" (click)="scrollPage()">
                <!-- <i class="fas fa-chevron-down"></i> -->
              </div>
              <ng-template *ngIf="isPaymentMethodOnline(); then ProceedToPayment; else SubmitYourOrder">
              </ng-template>
              <ng-template #SubmitYourOrder>
                <div
                  class="add-to-cart-wrapper d-flex flex-column w-100 mx-auto py-0 px-1 px-lg-0 font-size-primary text-unselectable"
                  [ngClass]="{'disabled': checkSubmitReadyAndStoreClose()}">
                  <div *ngIf="!isAdminUI">
                    <div *ngIf="this.selectedStore.settings.TERMS_AND_CONDITIONS_ACCEPTANCE === 'EXPLICIT'"
                      class="d-flex flex-row mx-3 pl-1 terms">
                      <input type="checkbox" formControlName="termsAccepted" (change)="termsAndConditions()" required>
                      <span class="checkmark" (click)="toggleCheckbox()"></span>
                      <div class="sticky-terms my-1 px-1 font-size-primary">{{'public.checkout.termsAndPolicy' |
                        translate}}
                        <a [href]="whitelabelService.getWhiteLabelTermsLink() | safe" target="_blank"
                          (click)="termsPrivacyComponent.openReadMoreModal($event, 'terms')">{{'public.checkout.termsOfUse'
                          |
                          translate}}</a>
                        {{'public.checkout.acceptTerms.and' | translate}}
                        <a [href]="whitelabelService.getWhiteLabelPrivacyLink() | safe" target="_blank"
                          (click)="termsPrivacyComponent.openReadMoreModal($event, 'policy')">{{'public.checkout.privacyPolicy'
                          |
                          translate}}</a>
                      </div>
                    </div>
                    <div
                      *ngIf="selectedStore.settings.TERMS_AND_CONDITIONS_ACCEPTANCE === 'EXPLICIT' && termsAcceptedForm.get('termsAccepted')?.invalid && termsAcceptedForm.get('termsAccepted')?.touched"
                      class=" px-3 ml-1 mb-2 font-size-primary error-center">
                      <span class="text-danger">{{ 'public.checkout.errorAcceptTerms' | translate }}</span>
                    </div>
                    <div *ngIf="this.selectedStore.settings.TERMS_AND_CONDITIONS_ACCEPTANCE === 'IMPLICIT'"
                      class="sticky-terms text-center my-1 px-1 font-size-secondary">
                      {{'public.checkout.termsAndPolicyImplicit' |
                      translate}}
                      <a [href]="whitelabelService.getWhiteLabelTermsLink() | safe" target="_blank"
                        (click)="termsPrivacyComponent.openReadMoreModal($event, 'terms')">{{'public.checkout.termsOfUse'
                        |
                        translate}}</a>
                      {{'public.checkout.acceptTerms.and' | translate}}
                      <a [href]="whitelabelService.getWhiteLabelPrivacyLink() | safe" target="_blank"
                        (click)="termsPrivacyComponent.openReadMoreModal($event, 'policy')">{{'public.checkout.privacyPolicy'
                        |
                        translate}}</a>
                    </div>
                  </div>
                  <a href="#" class="button dark d-block text-center py-3 mx-2 mx-lg-0"
                    (throttledClick)="OnSubmitOrder($event)" appPreventDoubleClick [throttleTime]="5000">
                    {{(isAdminOrderUpdate ? 'public.checkout.updateOrder' : 'public.payment.submitOrder') | translate}}
                    <span *ngIf="showTotalInButton && checkoutService.getCartTotal() > 0">( {{
                      checkoutService.getCartTotal() |
                      formatPrice:
                      checkoutService.selectedStoreLocale:checkoutService.selectedStoreCurrency:checkoutService.selectedStoreCurrencySymbol
                      }} )</span>
                  </a>
                </div>
              </ng-template>
              <ng-template #ProceedToPayment>
                <div
                  class="add-to-cart-wrapper d-flex flex-column w-100 mx-auto py-0 px-1 px-lg-0 font-size-primary text-unselectable"
                  [ngClass]="{'disabled': disableProceedToPaymentButton()}">
                  <div class="m-auto pb-2 d-none d-sm-block"
                    *ngIf="(this.selectedStore.settings.EPAY_PAYMENT_TYPE === 'ONLINE')">
                    <div class="row justify-content-center align-items-center logowidth">
                      <div class="mt-2">
                        <span><img src="./assets/img/visa.png" alt="visa" class="img-fluid mr-3"></span>
                        <span><img src="./assets/img/mastercard.png" alt="mastercard" class="img-fluid mr-3"></span>
                        <span><img src="./assets/img/maestro.png" alt="maestro" class="img-fluid mr-3"></span>
                        <span><img src="./assets/img/visa_secure.png" alt="visa_secure" class="img-fluid mr-3"></span>
                        <span><img src="./assets/img/mastercard_id.png" alt="mastercard_id"
                            class="img-fluid mr-3"></span>
                        <span><img src="./assets/img/epay.png" alt="epay" class="img-fluid"></span>
                      </div>
                    </div>
                  </div>
                  <div class="m-auto pb-2 d-block d-sm-none d-block"
                    *ngIf="(this.selectedStore.settings.EPAY_PAYMENT_TYPE === 'ONLINE')">
                    <div class="row mb-3 justify-content-center align-items-center logowidth">
                      <div class="mr-3 mt-2">
                        <img src="./assets/img/visa.png" alt="Image 1" class="img-fluid mr-3">
                        <img src="./assets/img/mastercard.png" alt="Image 2" class="img-fluid mr-3">
                        <img src="./assets/img/maestro.png" alt="Image 3" class="img-fluid">
                      </div>
                    </div>
                    <div class="row mb-3 justify-content-center align-items-center logowidth">
                      <div class="mr-3 mt-2">
                        <img src="./assets/img/visa_secure.png" alt="Image 4" class="img-fluid mr-3">
                        <img src="./assets/img/mastercard_id.png" alt="Image 5" class="img-fluid mr-3">
                        <img src="./assets/img/epay.png" alt="Image 6" class="img-fluid">
                      </div>
                    </div>
                  </div>
                  <div *ngIf="!isAdminUI">
                    <div *ngIf="this.selectedStore.settings.TERMS_AND_CONDITIONS_ACCEPTANCE === 'EXPLICIT'"
                      class="d-flex flex-row mx-3 pl-1 terms">
                      <input type="checkbox" formControlName="termsAccepted" (change)="termsAndConditions()" required>
                      <span class="checkmark" (click)="toggleCheckbox()"></span>
                      <div class="sticky-terms my-1 px-1 font-size-primary">{{'public.checkout.termsAndPolicy' |
                        translate}}
                        <a [href]="whitelabelService.getWhiteLabelTermsLink() | safe" target="_blank"
                          (click)="termsPrivacyComponent.openReadMoreModal($event, 'terms')">{{'public.checkout.termsOfUse'
                          |
                          translate}}</a>
                        {{'public.checkout.acceptTerms.and' | translate}}
                        <a [href]="whitelabelService.getWhiteLabelPrivacyLink() | safe" target="_blank"
                          (click)="termsPrivacyComponent.openReadMoreModal($event, 'policy')">{{'public.checkout.privacyPolicy'
                          |
                          translate}}</a>
                      </div>
                    </div>
                    <div
                      *ngIf="selectedStore.settings.TERMS_AND_CONDITIONS_ACCEPTANCE === 'EXPLICIT' && termsAcceptedForm.get('termsAccepted')?.invalid && termsAcceptedForm.get('termsAccepted')?.touched"
                      class="text-danger error-center font-size-primary px-3 ml-1 mb-2">
                      {{ 'public.checkout.errorAcceptTerms' | translate }}
                    </div>
                    <div *ngIf="this.selectedStore.settings.TERMS_AND_CONDITIONS_ACCEPTANCE === 'IMPLICIT'"
                      class="sticky-terms text-center my-1 px-1 font-size-secondary">
                      {{'public.checkout.termsAndPolicyImplicit' |
                      translate}}
                      <a [href]="whitelabelService.getWhiteLabelTermsLink() | safe" target="_blank"
                        (click)="termsPrivacyComponent.openReadMoreModal($event, 'terms')">{{'public.checkout.termsOfUse'
                        |
                        translate}}</a>
                      {{'public.checkout.acceptTerms.and' | translate}}
                      <a [href]="whitelabelService.getWhiteLabelPrivacyLink() | safe" target="_blank"
                        (click)="termsPrivacyComponent.openReadMoreModal($event, 'policy')">{{'public.checkout.privacyPolicy'
                        |
                        translate}}</a>
                    </div>
                  </div>

                  <a href="#" class="button dark d-block text-center py-3 mx-2 mx-lg-0 text-unselectable"
                    (throttledClick)="OnSubmitOrder($event)" id="proceed-payment" appPreventDoubleClick
                    [throttleTime]="5000">
                    {{'public.payment.proceedToPayment' | translate}} <span
                      *ngIf="showTotalInButton && checkoutService.getCartTotal() > 0">( {{
                      checkoutService.getCartTotal() |
                      formatPrice:
                      checkoutService.selectedStoreLocale:checkoutService.selectedStoreCurrency:checkoutService.selectedStoreCurrencySymbol
                      }} )</span>
                  </a>
                  <!-- Disable Paypal -->
                  <a href="{{paymentComponent.paypalActionUrl}}"
                    class="button dark d-block text-center py-3 mx-2 mx-lg-0 font-size-primary text-unselectable"
                    *ngIf="false && checkoutService.ifSubmitOrderReady() && checkoutService.getPaymentMethod() === PAYMENT_METHOD.PAYPAL">
                    {{'public.payment.proceedToPayment' | translate}} <span
                      *ngIf="showTotalInButton && checkoutService.getCartTotal() > 0">( {{
                      checkoutService.getCartTotal() |
                      formatPrice:
                      checkoutService.selectedStoreLocale:checkoutService.selectedStoreCurrency:checkoutService.selectedStoreCurrencySymbol
                      }} )</span>
                  </a>
                </div>
              </ng-template>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
</div>
<app-offer-unavailable-dialog></app-offer-unavailable-dialog>
<app-reservable-offers-exceeded-dialog></app-reservable-offers-exceeded-dialog>
<app-offers-already-reserved-dialog></app-offers-already-reserved-dialog>
<app-offer-outofstock-dialog></app-offer-outofstock-dialog>
<app-unavailable-slot-dialog></app-unavailable-slot-dialog>
<app-same-day-ordering-dialog></app-same-day-ordering-dialog>
<app-store-checkout-error-dialog></app-store-checkout-error-dialog>
<app-terms-privacy #termsPrivacyComponent></app-terms-privacy>
<app-store-payment-error-dialog></app-store-payment-error-dialog>